import clsx from "clsx";
import React from "react";

function CountdownTimer({ durationToMeeting, small, grey }) {
  return durationToMeeting ? (
    <div className="flex items-center justify-center gap-2.5">
      {Object.keys(durationToMeeting).map((key, i) => (
        <div
          key={i}
          className="flex items-center justify-center text-[#7575A8]"
        >
          <div
            className={clsx(
              "flex items-center justify-center text-white bg-[#30307D] rounded-[4px] mr-1 w-[30px] h-[30px]",
              {
                "!w-[26px] !h-[26px]": small,
                "!bg-[#E8E8F1] !text-[#202053] font-bold": grey,
              }
            )}
          >
            {durationToMeeting[key]}
          </div>
          {key}
        </div>
      ))}
    </div>
  ) : null;
}

export default CountdownTimer;
